import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container purchasesummary-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"text-align":"center","color":"#333"}
}, " Something went wrong. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin-top":"4px","line-height":"22px"} }, " Please try again. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", {
  width: "20%",
  valign: "top"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "bigerror-x" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Your Renters Insurance", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.nssi.com/contact-us",
    target: "_blank"
  }, " Contact NSSI "),
  /*#__PURE__*/_createTextVNode(" for help or to report an issue"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createTextVNode("Failed! You're "),
  /*#__PURE__*/_createElementVNode("u", null, "NOT"),
  /*#__PURE__*/_createTextVNode(" Covered.")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { style: {"text-align":"center","line-height":"22px"} }

import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { AssurantData } from "@/api/AssurantData";
import { ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteDoneFailedRentersApi',
  setup(__props) {

const loading = ref(false);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

const getId = async () => {
  try {
    const cartId = await NssiData.toRemote(quote);
    return cartId;
  } catch (error) {
    console.log(error);
  }
};

const retryIssuePolicy = async () => {
  loading.value = true;

  if (quote.rentersInsurance && !quote.assurantPassed) {
    const result = await AssurantData.issuePolicy(quote);
    if (result.error) {
      quote.assurantPassed = false;
      quote.assurantPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-assurant-failed-api");
      return;
    } else {
      quote.assurantPassed = true;
      quote.rentersInsurance.policyNumber =
        result.result.transactionDetails.policyId;
      quote.assurantPolicyError = "";
    }
  }

  if (quote.personalInsurance && !quote.nssiPassed) {
    const result = await NssiData.issuePolicy(quote, user, getId);

    if (result.error) {
      quote.nssiPassed = false;
      quote.nssiPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-nssi-failed-api");
      return;
    } else {
      quote.nssiPassed = true;
      //quote.personalInsurance.orderId = result.policy.PolicyID;
      quote.personalInsurance.policyNumber = result.policy;
      quote.nssiPolicyError = "";
    }
  }

  loading.value = false;
  quote.setQuoteStep("quote-done");
};

function quoteDone() {
  quote.done = true;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("table", {
        width: "100%",
        style: {"max-width":"600px"},
        border: "0",
        cellspacing: "0",
        cellpadding: "0",
        class: "mobilecollpasetable",
        align: "center"
      }, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", {
              valign: "top",
              class: "error"
            }, [
              _createElementVNode("table", {
                width: "100%",
                border: "0",
                cellspacing: "0",
                cellpadding: "0"
              }, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    _createElementVNode("td", { valign: "top" }, [
                      _hoisted_11,
                      _createElementVNode("div", { class: "try" }, [
                        _createTextVNode(" Things you can try..."),
                        _hoisted_12,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: retryIssuePolicy
                            }, "Retry"),
                            _createTextVNode(" transaction "),
                            _hoisted_13
                          ]),
                          _hoisted_14
                        ])
                      ]),
                      _hoisted_15,
                      _hoisted_16
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _createElementVNode("p", _hoisted_21, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (quoteDone()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Return to homepage")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})